// WishlistForm.js
import React, { useState } from 'react';
import axios from 'axios';

const WishlistForm = ({ id, onAdd }) => {
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let imageUrl = '';

      if (image) {
        console.log("Uploading image to WordPress...");

        const formData = new FormData();
        formData.append('file', image);
        formData.append('alt_text', 'invite_gallery'); // ← Add this

        const wpRes = await axios.post(
          `${process.env.REACT_APP_PAY_BASE_URL}/wp-json/wp/v2/media`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization:
                'Basic ' + btoa(`${process.env.REACT_APP_WP_USERNAME}:${process.env.REACT_APP_WP_APP_PASSWORD}`),
            },
          }
        );

        imageUrl = wpRes.data.source_url;
        console.log("Image uploaded successfully:", imageUrl);
      }

      console.log("Submitting wishlist to Laravel with data:", {
        card_id: id,
        title,
        url,
        image_url: imageUrl,
      });

      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/wishlists`, {
        card_id: id,
        title,
        url,
        image_url: imageUrl,
      });

      console.log("Wishlist saved successfully:", res.data);

      setTitle('');
      setUrl('');
      setImage(null);
      setPreviewUrl('');
      onAdd();
    } catch (err) {
      console.error('Error submitting wishlist:', err.response?.data || err.message || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">Item Title</label>
        <input
          type="text"
          value={title}
          placeholder="Enter title"
          onChange={(e) => setTitle(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Item URL (optional)</label>
        <input
          type="url"
          value={url}
          placeholder="Enter URL"
          onChange={(e) => setUrl(e.target.value)}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Upload Image (optional)</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="w-full"
        />
        {previewUrl && (
          <img
            src={previewUrl}
            alt="Preview"
            className="mt-2 w-32 h-32 object-cover rounded"
          />
        )}
      </div>

      <button
        type="submit"
        disabled={loading}
        className="btn-primary"
      >
        {loading ? 'Saving...' : 'Save Wishlist'}
      </button>
    </form>
  );
};

export default WishlistForm;
